import { usePasswordChangeModalPresenter } from '@Components/Modals/ChangePasswordModal/ChangePasswordPresenter';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { RouteNames } from '~types/navigation';
import type { RootStackParamList } from '~types/navigation';

type ScreenProps = NativeStackScreenProps<
  RootStackParamList,
  RouteNames.ChangePassword
>;

type Props = ScreenProps & object;

const ChangePassword = ({ route, navigation }: Props) => {
  const { show: showPasswordResetModal } = usePasswordChangeModalPresenter();

  useEffect(() => {
    const { token } = route.params;
    showPasswordResetModal(token);
    navigation.replace(RouteNames.BigBrowse, { journey: 'brandconcession' });
  }, []);

  return null;
};

export default observer(ChangePassword);
